<template>
  <div>
    <el-card>
      <el-row :gutter="20" class="mb-20">
        <el-col :span="6">
          <el-select v-model="searchParams.gameId" placeholder="按游戏查询" clearable>
            <el-option
              v-for="game in gameOptions"
              :key="game.value"
              :label="game.label"
              :value="game.value"
            />
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-input v-model="searchParams.userId" placeholder="按用户ID查询" clearable />
        </el-col>
        <el-col :span="6">
          <el-button type="primary" @click="handleSearch">查询</el-button>
        </el-col>
      </el-row>

      <el-table :data="orderList" border style="width: 100%; max-height: 600px; overflow-y: auto;">
        <el-table-column prop="id" label="订单ID" width="100" />
        <el-table-column prop="user.account" label="用户" />
        <el-table-column prop="game.name" label="游戏" />
        <el-table-column label="玩法" width="300">
          <template #default="{ row }">
            <div style="white-space: nowrap" v-for="(item, index) in row.lottery_odds" :key="index">
              <a v-for="(subItem, subIndex) in item.split('@')" :key="subIndex">
                {{ item.split('@').length > subIndex + 1 ? $t('pay.' + subItem) + '@' : subItem }}
              </a>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="bet_numbers" label="期数" />
        <el-table-column prop="bet_amount" label="投注金额" />
        <el-table-column prop="bet_amount_all" label="投注总额" />
        <el-table-column prop="win_amount" label="中奖金额" />
        <el-table-column prop="is_settled" label="是否结算">
          <template #default="{ row }">
            <el-tag :type="row.is_settled ? 'success' : 'danger'">
              {{ row.is_settled ? '已结算' : '未结算' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="投注时间" width="180" />
      </el-table>

      <el-pagination
        :current-page="pagination.page"
        :page-size="pagination.limit"
        :total="total"
        @current-change="handlePageChange"
      />
    </el-card>
  </div>
</template>

<script>
import { getBets } from '@/api/order';
import { getLotteryGames } from '@/api/lotteryGame';
import i18n from '@/i18n'


export default {
  data() {
    return {
      searchParams: {
        gameId: null,
        userId: null
      },
      gameOptions: [],
      orderList: [],
      pagination: {
        page: 1,
        limit: 20
      },
      total: 0,
      t: i18n.t
    };
  },
  created() {
    this.fetchData();
    this.fetchGameOptions();
  },
  methods: {
    async fetchData() {
      const params = {
        ...this.searchParams,
        page: this.pagination.page,
        limit: this.pagination.limit
      };
      const { data } = await getBets(params);
      this.orderList = data.rows;
      this.total = data.count;
    },
    async fetchGameOptions() {
      const { data } = await getLotteryGames();
      this.gameOptions = data.rows.map(game => ({
        value: game.id,
        label: game.name
      }));
    },
    handleSearch() {
      this.pagination.page = 1;
      this.fetchData();
    },
    handlePageChange(page) {
      this.pagination.page = page;
      this.fetchData();
    }
  }
};
</script>

<style scoped>
.el-card {
  margin: 20px;
}

.mb-20 {
  margin-bottom: 20px;
}

.el-pagination {
  margin-top: 20px;
  text-align: right;
}
</style>